<template lang="html">
  <div class="default" />
</template>

<script>
  export default {};
</script>

<style scoped lang="stylus">

  /****** Import Global Stylus ******/

  @import '~app/global-stylus'

  /****** Defaults ******/

  setBorderSize(n)
    border: (n)px solid pl-fog
    border-top: (n)px solid pl-primary
    border-bottom: (n)px solid pl-ruby
    border-left: (n)px solid pl-secondary

  @-webkit-keyframes spin
    0% { -webkit-transform: rotate(0deg) }
    100% { -webkit-transform: rotate(360deg) }

  @keyframes spin
    0%
      transform: rotate(0deg)
    50%
      transform: rotate(310deg)
    100%
      transform: rotate(360deg)

  default =
    margin: 0
    border-radius: 50%
    -webkit-animation: spin 2s linear infinite
    animation: spin 1.5s linear infinite

  .default
    {default}
    setBorderSize(4)
    width: 30px
    height: 30px

  .x2
    {default}
    setBorderSize(8)
    width: 60px
    height: 60px

  .x3
    {default}
    setBorderSize(10)
    width: 90px
    height: 90px

  .x4
    {default}
    setBorderSize(12)
    width: 120px
    height: 120px
</style>



// WEBPACK FOOTER //
// plSpinner.vue?07c61b0e